/* Native disclosure navigation. All links remain usable without JavaScript. */
(function () {
  'use strict';
  const desktop = window.matchMedia('(min-width: 821px)');
  function applyCategories() {
    document.querySelectorAll('.native-header .native-category').forEach(function (detail) {
      detail.open = desktop.matches;
    });
  }
  function initialize() {
    applyCategories();
    document.querySelectorAll('.native-mega').forEach(function (detail) {
      if (detail.dataset.navigationReady) return;
      detail.dataset.navigationReady = 'true';
      detail.addEventListener('toggle', function () {
        if (detail.open) document.querySelectorAll('.native-mega[open]').forEach(function (other) {
          if (other !== detail) other.open = false;
        });
      });
    });
  }
  document.addEventListener('click', function (event) {
    if (!event.target.closest('.native-mega')) document.querySelectorAll('.native-mega[open]').forEach(function (detail) { detail.open = false; });
  });
  document.addEventListener('keydown', function (event) {
    if (event.key !== 'Escape') return;
    const active = document.activeElement && document.activeElement.closest('.native-mega[open]');
    document.querySelectorAll('.native-mega[open]').forEach(function (detail) { detail.open = false; });
    if (active) active.querySelector('summary').focus();
  });
  if (desktop.addEventListener) desktop.addEventListener('change', applyCategories);
  document.addEventListener('shopify:section:load', initialize);
  initialize();
})();
